import { Project } from '@/types';
import { Device } from '@/types';

export class ProjectMutator {
  public static toTabular(project: Project): any {
    return {
      project: {
        value: project.name,
        property: 'project.name',
      },
      devices_count: {
        value: project.devices_count || 0,
        property: 'project.devices_count',
        align: 'center',
      },
      devices_active_count: {
        value: project.devices_active_count || 0,
        property: 'project.devices_active_count',
        align: 'center',
      },
      devices_inactive_count: {
        value: project.devices_inactive_count || 0,
        property: 'project.devices_inactive_count',
        align: 'center',
      },
      devices_fault_count: {
        value: project.devices_fault_count || 0,
        property: 'project.devices_fault_count',
        align: 'center',
      },
      owner: {
        value: project.user ? `${project.user.first_name} ${project.user.last_name} (${project.user.email})` : null,
        property: 'user.email',
      },
      id: project.id,
    };
  }
}
